import { createAction } from '@reduxjs/toolkit';

export interface TaskJobFilters {
    page: number;
    page_size: number;
    task_type?: string | null;
    status?: string | null;
    username?: string | null;
}

export interface TaskJobItem {
    id: number;
    task_id: string;
    task_type: string;
    session_id?: string | null;
    user_username: string;
    user_full_name: string;
    created_at: string;
    started_at?: string | null;
    completed_at: string | null;
    status: string;
    status_display?: string;
    duration_seconds: number | null;
    progress_percentage: number;
    task_data: any;
    result_data: any;
    error_message: string | null;
}

export const FETCHING_TASK_JOBS = 'FETCHING_TASK_JOBS';
export const RETRY_TASK_JOB = 'RETRY_TASK_JOB';
export const CANCEL_TASK_JOB = 'CANCEL_TASK_JOB';
export const DELETE_TASK_JOB = 'DELETE_TASK_JOB';

export const fetchTaskJobs = createAction(FETCHING_TASK_JOBS, (filters: TaskJobFilters) => ({
    payload: filters,
}));

export const retryTaskJob = createAction(RETRY_TASK_JOB, (taskId: string) => ({
    payload: { taskId },
}));

export const cancelTaskJob = createAction(CANCEL_TASK_JOB, (taskId: string) => ({
    payload: { taskId },
}));

export const deleteTaskJob = createAction(DELETE_TASK_JOB, (taskId: string) => ({
    payload: { taskId },
}));
